<script setup lang="ts">
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import RoomCard from './RoomCard.vue';
import LabelView from '@components/util/LabelView.vue';
import type RoomsPackage from '@itinerary/hotel/RoomsPackage';

interface IProps {
    roomsPackage: RoomsPackage;
    nights?: number;
    isSelected?: boolean;
}
const { nights = 1, isSelected, roomsPackage } = defineProps<IProps>();

const emit = defineEmits<{
    select: [];
}>();

const { isMobile } = useSize();
</script>

<template>
    <div class="packaged-rooms-card">
        <div class="rooms-list">
            <template
                v-for="(item, i) in roomsPackage.roomsList"
                :key="item.room.id"
            >
                <mr-divider v-if="i > 0" />
                <RoomCard
                    class="room-card"
                    :item="item.room"
                    :nights
                    hide-reserve
                >
                    <template #header-start>
                        <LabelView
                            :label="{
                                title: `${item.count} اتاق`,
                                backgroundColor: 'var(--cool-gray-100)',
                                color: 'var(--cool-gray-600)',
                            }"
                        />
                    </template>
                </RoomCard>
            </template>
        </div>
        <mr-divider :vertical="!isMobile" />
        <div class="pricing">
            <mr-checkbox
                class="mobile-radio"
                :model-value="isSelected"
                label="انتخاب اتاق‌ها"
                is-radio
                @click="emit('select')"
            />
            <mr-price-re
                :price="roomsPackage.payablePrice"
                :prefix="`${nights} شب`"
                sign="+"
            />
            <mr-button
                class="desktop-button"
                full-width
                :variant="isSelected ? 'bordered' : 'filled'"
                :right-icon="isSelected ? faCheck : undefined"
                @click="emit('select')"
            >
                {{ isSelected ? 'انتخاب شده ' : 'انتخاب اتاق‌ها' }}
            </mr-button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.packaged-rooms-card {
    display: flex;
    background-color: white;
    @include shadow();
    border-radius: 12px;
    overflow: hidden;
    @include mobile-only {
        flex-direction: column;
    }
    .rooms-list {
        flex: 1;
        .room-card {
            box-shadow: none !important;
            border-radius: 0 !important;
        }
    }
    .pricing {
        width: 210px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 12px;
        gap: 8px;
        @include mobile-only {
            width: auto;
            flex-direction: row;
            justify-content: space-between;
        }
        .mobile-radio {
            display: none;
            @include mobile-only {
                display: flex;
            }
        }
        .desktop-button {
            @include mobile-only {
                display: none;
            }
        }
    }
}
</style>
